import { animateNextPost } from './animationFunctions'

export function postsSetup(postsImages, postsCopys, wrapper) {
  const postsArray = []
  let i = 0

  postsImages.forEach((post) => {
    const tick = document.createElement('div')
    wrapper.appendChild(tick)
    const postsObject = {
      image : postsImages[i],
      copy : postsCopys[i],
      pip: tick,
      index: i,
    }
    tick.classList.add('c-slider-pip')
    postsArray.push(postsObject)
    i++
  })
  return postsArray
}

export function handlePips(posts) {
  posts.forEach((post) => {
    if (post.image.dataset.active == 'true') {
      post.pip.classList.add('c-slider-pip--active')
    } else {
      post.pip.classList.remove('c-slider-pip--active')
    }
  })
}

export function initializeButtons(posts) {
  const buttons = [
    document.querySelector('.c-slider__previous'),
    document.querySelector('.c-slider__next'),
  ]
  const postsArray = posts
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const activePost = findActivePost(posts)
      const modifier = button.classList.contains('c-slider__previous') ? -1 : 1
      handleButtonInput(modifier, postsArray, activePost)
    })
  })
}

export function handleButtonInput(modifier, posts, activePost) {
  let nextPost
  posts.forEach((post) => {
    if (post.index == activePost.index + modifier) {
      nextPost = post
    }
  })
  if (nextPost) {
    animateNextPost(activePost, nextPost)
    setActivePost(posts, nextPost)
    handlePips(posts, nextPost.pip)
  }
}

export function setActivePost(posts, post) {
  const activePost = post
  posts.forEach((post) => {
    if (post == activePost) {
      post.image.dataset.active = 'true'
    } else {
      post.image.dataset.active = 'false'
    }
  })
}

export function deactivatePost(post) {
  post.image.dataset.active = 'false'
}

export function findActivePost(posts) {
  let activePost
  posts.forEach((post) => {
    if (post.image.dataset.active == 'true') {
      activePost = post
    }
  })
  return activePost
}
